import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { ManageUsersComponent } from './pages/manage-users/manage-users.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { SingleUserProfileComponent } from './pages/single-user-profile/single-user-profile.component';
import { ViewAllProductsComponent } from './pages/products/view-all-products/view-all-products.component';
import { InstitutionsComponent } from './pages/institutions/institutions.component';
import { InstitutionDetailsComponent } from './pages/institutions/institution-details/institution-details.component';
import { authGuard } from './guard/auth.guard';
import { sectionGuard, manageSectionGuard } from './guard/section.guard';
import { ProductDetailsComponent } from './pages/products/product-details/product-details.component';
import { OverviewComponent } from './pages/products/product-details/overview/overview.component';
import { RepaymentsComponent } from './pages/products/product-details/repayments/repayments.component';
import { InstitutionsComponent as ProductInstitutionsComponent } from './pages/products/product-details/institutions/institutions.component';
import {
    ApplicantDetailsComponent
} from './pages/products/product-details/repayments/applicant-details/applicant-details.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { ForgotPasswordComponent } from './pages/auth/forgot-password/forgot-password.component';
import { PhoneVerificationComponent } from './pages/phone-verification/phone-verification.component';
import { PhotoCaptureComponent } from './pages/photo-capture/photo-capture.component';
import { ApiKeysComponent } from './pages/api-keys/api-keys.component';
import { LoanApplicationsComponent } from './pages/loan-applications/loan-applications.component';
import { WebhookTriggerComponent } from './pages/webhook-trigger/webhook-trigger.component';
import { GuarantorFormComponent } from './pages/guarantor-form/guarantor-form.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ApplicationFormsComponent } from './pages/application-forms/application-forms.component';
import { FormBuilderComponent } from './pages/application-forms/form-builder/form-builder.component';
import { ApplyFormComponent } from './pages/apply-form/apply-form.component';

export const routes: Routes = [
    // Public pages (no authentication required - accessible without login)
    // These must be defined BEFORE the default redirect to ensure they're matched first
    { path: 'phone-verification', component: PhoneVerificationComponent },
    { path: 'photo-capture', component: PhotoCaptureComponent },
    { path: 'guarantor/:token', component: GuarantorFormComponent },
    { path: 'apply/:token', component: ApplyFormComponent },
    { path: '404', component: NotFoundComponent },

    // authentication (no auth guard - public)
    {
        path: 'auth',
        component: AuthLayoutComponent,
        children: [
            { path: 'login', component: LoginComponent },
            { path: 'forgot-password', component: ForgotPasswordComponent },
            { path: '', redirectTo: 'login', pathMatch: 'full' }
        ],
    },

    // main layout
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'manage-users', component: ManageUsersComponent, canActivate: [sectionGuard('adminMgmt')] },
            { path: 'api-keys', component: ApiKeysComponent, canActivate: [sectionGuard('apiKeys')] },
            { path: 'user-profile', component: SingleUserProfileComponent },
            {
                path: 'dashboard',
                loadComponent: () =>
                    import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
            },
            { path: 'products', component: ViewAllProductsComponent, canActivate: [sectionGuard('products')] },
            { path: 'categories', component: CategoriesComponent, canActivate: [sectionGuard('categories')] },
            { path: 'institutions', component: InstitutionsComponent, canActivate: [sectionGuard('institutions')] },
            { path: 'loan-applications', component: LoanApplicationsComponent, canActivate: [sectionGuard('applications')] },
            { path: 'webhook-trigger', component: WebhookTriggerComponent, canActivate: [sectionGuard('webhooks')] },
            { path: 'application-forms', component: ApplicationFormsComponent, canActivate: [sectionGuard('applicationForms')] },
            { path: 'application-forms/new', component: FormBuilderComponent, canActivate: [manageSectionGuard('applicationForms')] },
            { path: 'application-forms/:id/edit', component: FormBuilderComponent, canActivate: [manageSectionGuard('applicationForms')] },
            { path: 'institution-detail/:id', component: InstitutionDetailsComponent, canActivate: [sectionGuard('institutions')] },
            {
                path: 'product-details/:productId',
                component: ProductDetailsComponent,
                canActivate: [sectionGuard('products')],
                children: [
                    { path: 'overview', component: OverviewComponent },
                    { path: 'repayments', component: RepaymentsComponent },
                    { path: 'institution', component: ProductInstitutionsComponent },
                    { path: 'applicant/:applicationId', component: ApplicantDetailsComponent },
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                ]
            },

        ],
        canActivate: [authGuard] // Ensure user is authenticated
    },

    { path: '**', redirectTo: '404' },
];
